import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CustomModal from '../../../../../components/custom-modal/CustomModal';
import { LoadingButton } from '@mui/lab';


const CryopeserveLsmModal = ({open, setOpen, setOpenModal }) => {
    
    const handleCryopreserved = async () => {
        setOpenModal(true)
        setOpen(false)
    }

    return ( 
      <CustomModal open={open} setOpen={setOpen}>
        <div className="h-full flex flex-col gap-8 pl-3 pr-3 pt-4">
          {/* <div className="self-center">
            <DeleteModalIcon />
            </div> */}
          <Typography
            align="center"
            id="spring-modal-title"
            variant="h5"
            fontWeight={500}
            component="h5"
          >
            Would you like to move forward with cryopreservation or begin the manufacturing process with them?
          </Typography>
         <div className="flex justify-center gap-4">
           
            <LoadingButton
              variant="contained"
              className="w-[160px] h-[40px]"
              onClick={handleCryopreserved}
            >
              <span>Cryopreserve LSM</span>
            </LoadingButton>

            <Button
              variant="contained"
              className="w-[200px] h-[40px]"
              sx={{backgroundColor:"white",color:'currentColor','&:hover':{backgroundColor:"black",color:"white"},border:"1px solid Gray",}}
              onClick={() => {
                 setOpen(false)
              }}
            >
               Manufacturing
            </Button>
          </div>
        </div>
      </CustomModal>);
}
export default CryopeserveLsmModal;